import { render, staticRenderFns } from "./UsersModal.vue?vue&type=template&id=58ba8690"
import script from "./UsersModal.vue?vue&type=script&lang=js"
export * from "./UsersModal.vue?vue&type=script&lang=js"
import style0 from "./UsersModal.vue?vue&type=style&index=0&id=58ba8690&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports